import L from 'leaflet';
import { formatPriceForPin } from './currencyFormatter'; // Corrected path
import './mapIconUtils.css'; // Import the CSS file for styling

/**
 * Creates a custom Leaflet DivIcon to display a formatted property price.
 * @param {number|string} price - The property price.
 * @returns {L.DivIcon} - A Leaflet DivIcon instance.
 */
export const createPriceIcon = (price) => {
  const formattedPrice = formatPriceForPin(price);
  return L.divIcon({
    html: `<div class="price-marker-body">${formattedPrice}</div><div class="price-marker-pin"></div>`,
    className: 'price-marker-container', // CSS class for styling
    iconSize: [36, 30], // NEW smaller size: Width and height of the entire icon (body + pin)
    iconAnchor: [18, 30], // Anchor at the bottom center of the pin
    popupAnchor: [0, -30], // Popup appears directly above the marker
  });
};

/**
 * Creates a custom Leaflet DivIcon for a hovered property price.
 * @param {number|string} price - The property price.
 * @returns {L.DivIcon} A Leaflet DivIcon instance.
 */
export const createHoverIcon = (price) => {
  const formattedPrice = formatPriceForPin(price);
  return L.divIcon({
    html: `<div class="price-marker-body hover">${formattedPrice}</div><div class="price-marker-pin hover"></div>`, // Add 'hover' class for different styling
    className: 'price-marker-container',
    iconSize: [36, 30], // NEW smaller size: Width and height of the entire icon (body + pin)
    iconAnchor: [18, 30], // Anchor at the bottom center of the pin
    popupAnchor: [0, -30], // Popup appears directly above the marker
  });
};

/**
 * Creates a custom Leaflet DivIcon to display a neighborhood name label.
 * @param {string} name - The name of the neighborhood.
 * @returns {L.DivIcon} - A Leaflet DivIcon instance.
 */
export const createNeighborhoodLabelIcon = (name) => {
  return L.divIcon({
    html: `<div class="label-content">${name}</div>`,
    className: 'neighborhood-label-container', // CSS class for styling
    iconSize: null, // Let CSS control size
    iconAnchor: [30, 8], // Adjust anchor point as needed for label positioning
  });
};
